import React from "react";
import * as actionTypes from "store/actions/actionTypes";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { getCachedItem } from "utils/localStorage";
import {
  screenKeys,
  screenSaverTime,
  initScreen,
  deviceFloorLevel,
  mapOrientation,
  deviceSvgId,
} from "config/constants";

const ScreenSelect = () => {
  const dispatch = useDispatch();
  const screenSaverTimeState = useSelector((state) => state.screenSaverTime);

  const saveScreen = (scr) => {
    dispatch({
      type: actionTypes.SET_START_SCREEN,
      payload: scr,
    });
    dispatch({ type: actionTypes.CLEAR_ALL_FILTER });
    localStorage.setItem(initScreen, scr);
  };

  const handleSetScreenSaverTime = (e) => {
    dispatch({
      type: actionTypes.SET_SCREENSAVER_TIME,
      payload: e.target.value,
    });
    localStorage.setItem(screenSaverTime, e.target.value);
  };

  const mapOrientationData = getCachedItem(mapOrientation);
  const deviceFloorLevelData = getCachedItem(deviceFloorLevel);
  const deviceSvgIdData = getCachedItem(deviceSvgId);
  const hasData =
    mapOrientationData != undefined &&
    deviceFloorLevelData != undefined &&
    deviceSvgIdData != undefined;

  return (
    <div className={"row mt-5"}>
      <div className="offset-4 col-4">
        {!hasData ? (
          <p className="text-center">
            You must configure floor, location and orientation to select
            FoodCoast and Kiosk mode
          </p>
        ) : (
          <>
            <Link
              className="btn btn-primary w-100 text-center mb-4"
              to={`/${screenKeys.foodcourt}`}
              onClick={() => saveScreen(screenKeys.foodcourt)}
            >
              FoodCoast
            </Link>
            <Link
              className="btn btn-secondary w-100 text-center mb-4"
              to={`/${screenKeys.kiosk}`}
              onClick={() => saveScreen(screenKeys.kiosk)}
            >
              Kiosk
            </Link>
          </>
        )}

        <Link
          className="btn btn-warning w-100 text-center  mb-4"
          to={`/${screenKeys.restaurant}`}
          onClick={() => saveScreen(screenKeys.restaurant)}
        >
          Restaurant
        </Link>

        <div className="form-group mt-5">
          <div className="font-weight-bold">
            Screen Saver appears after:{" "}
            <select
              value={screenSaverTimeState}
              onChange={handleSetScreenSaverTime}
            >
              {[1, 2, 3, 4, 5].map((option) => (
                <option value={option} key={option}>
                  {option}
                </option>
              ))}
            </select>{" "}
            minutes
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScreenSelect;
